import React from "react";
import PropTypes from "prop-types";
import ReactInterval from "react-interval";
// import material-ui components
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/styles"
import TablePagination from "@material-ui/core/TablePagination";
// import material-ui icons
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "components/Table/Table.jsx";
import ConfirmDeleteDialog from "components/Dialogs/ConfirmDeleteDialog";
import OrganizationDialog from "components/Dialogs/OrganizationDialog";
import SuccessDialog from "components/Dialogs/SuccessDialog";
import ErrorDialog from "components/Dialogs/ErrorDialog";

import * as actionCreators from "actions/organizations";

import usersStyle from "assets/jss/material-dashboard-react/views/usersStyle"

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        organizations: state.organizations.organizations,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class OrganizationsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationsData: [],
            timeoutEnabled: false,
            organizationDialogIsOpened: false,
            organizationDialogIsNew: false,
            organizationDialogData: null,
            deleteOrganizationDialogIsOpened: false,
            deleteOrganizationsId: null,
            organizationsRowsPerPage: 25,
            organizationsPage: 1,
            successDialogIsOpened: false,
            errorDialogIsOpened: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        const { classes } = this.props;
        this.setState((prevState) => ({
            ...prevState,
            organizationsData: nextProps.organizations.isLoaded  ? nextProps.organizations.data.map((prop) => (
                [prop.id, prop.name, prop.is_master ? <CheckBoxIcon/> : <CheckBoxBlankIcon/>,
                    (<div>
                    <Button justIcon round simple color="transparent" className={classes.tableButton}
                            onClick={() => this.organizationDialogOpen(prop.id)}
                    >
                        <EditIcon/>
                    </Button>
                    <Button justIcon round simple color="danger" className={classes.tableButton}
                            onClick={() => this.deleteOrganizationDialogOpen(prop.id)}
                    >
                        <DeleteIcon/>
                    </Button>
                </div>)])) : prevState.organizationsData,

        }))
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true,
        });
        this.getData();
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }

    getData(){
        this.props.getOrganizations(this.props.token, this.state.organizationsPage, this.state.organizationsRowsPerPage);
    }

    deleteOrganizationDialogOpen(id){
        this.setState({
            deleteOrganizationDialogIsOpened: true,
            deleteOrganizationId: id,
        })
    }

    deleteOrganizationDialogClose(){
        this.setState({
            deleteOrganizationDialogIsOpened: false,
            deleteOrganizationId: null,
        })
    }



    deleteOrganization(){
        this.deleteOrganizationDialogClose();
        this.props.deleteOrganization(this.props.token, this.state.deleteOrganizationId).then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()});
        this.setState({
            deleteOrganizationId: null,
        }, this.getData)
    }

    organizationDialogOpen(organizationId){
        this.setState({
            organizationDialogIsOpened: true,
            organizationDialogIsNew: !organizationId,
            organizationDialogData: (organizationId && this.props.organizations.isLoaded)
                ? this.props.organizations.data.map((organization) => (organization.id === organizationId ? organization : null)).filter(n => n)[0] : null,
        })
    }

    organizationDialogClose(){
        this.setState({
            organizationDialogIsOpened: false,
            organizationDialogData: null,
        })
    }

    saveOrganization(organization){
        this.organizationDialogClose();
        if (!this.state.organizationDialogIsNew) {
            this.props.editOrganization(this.props.token, organization)
                .then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()})
        } else {
            this.props.createOrganization(this.props.token, organization)
                .then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()})
        }
        this.getData();
    }

    handleOrganizationChangePage(page){
        this.setState({
            organizationPage: page
        }, this.getData)
    }

    handleOrganizationChangeRowsPerPage(e){
        if (e.target.value !== this.state.organizationsRowsPerPage) {
            this.setState({
                organizationsRowsPerPage: e.target.value
            }, this.getData);
        }
    }

    successDialogShow(){
        this.setState({
            successDialogIsOpened: true,
        })
    }

    successDialogClose(){
        this.setState({
            successDialogIsOpened: false,
        })
    }

    errorDialogOpen(){
        this.setState({
            errorDialogIsOpened: true,
        })
    }

    errorDialogClose(){
        this.setState({
            errorDialogIsOpened: false,
        })
    }

    render(){
        const { classes } = this.props;
        return (
            <div>
                <Card>
                    <CardHeader color="info">
                        <Grid container>
                            <GridItem xs={6} s={10} md={10}>
                                <h4>Организации</h4>
                            </GridItem>
                            <GridItem xs={6} s={2} md={2}>
                                <Button color="info" className={classes.headerButton} onClick={() => this.organizationDialogOpen()}>
                                    <AddIcon className={classes.icons}/>Новая
                                </Button>
                            </GridItem>
                        </Grid>
                    </CardHeader>
                    <CardBody>
                        <Table
                            tableHead={["ID", "Название", "Мастер", ""]}
                            tableData={this.state.organizationsData}
                            tablePagination={(<TablePagination count={this.props.organizations.count || 0}
                                                           onChangePage={(e, page) => this.handleOrganizationChangePage(page + 1)}
                                                           page={this.state.organizationsPage - 1} rowsPerPage={this.state.organizationsRowsPerPage}
                                                           labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                           labelRowsPerPage="Строк на страницу:" component="div"
                                                           onChangeRowsPerPage={(e) => this.handleOrganizationChangeRowsPerPage(e)}
                            />)}
                        />
                    </CardBody>
                    <ConfirmDeleteDialog onCancel={() => this.deleteOrganizationDialogClose()} onSave={() => this.deleteOrganization()}
                                         isOpened={this.state.deleteOrganizationDialogIsOpened}
                                         bodyText="Вы точно хотите удалить данную организацию? Это действие нельзя будет отменить."
                    />
                    <OrganizationDialog onCancel={() => this.organizationDialogClose()} onSave={(org) => this.saveOrganization(org)}
                                        isOpened={this.state.organizationDialogIsOpened} organizationData={this.state.organizationDialogData}
                                        isNew={this.state.organizationDialogIsNew}
                    />
                </Card>
                <SuccessDialog onClose={() => this.successDialogClose()} isOpened={this.state.successDialogIsOpened}/>
                <ErrorDialog onClose={() => this.errorDialogClose()} isOpened={this.state.errorDialogIsOpened}/>
                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
        )
    }
}

OrganizationsView.propTypes = {
    getOrganizations: PropTypes.func,
    createOrganization: PropTypes.func,
    editOrganization: PropTypes.func,
    deleteOrganization: PropTypes.func,
    token: PropTypes.string,
    organizations: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
        count: PropTypes.number,
        pages: PropTypes.number,
        page: PropTypes.number,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(usersStyle)(OrganizationsView));


// WEBPACK FOOTER //
// ./src/views/Organizations/Organizations.jsx